import { apiEsign } from "@/api/esign.api.ts";
import { useDownloadHelper } from "@/hooks/use-download.helper.ts";
import { useOpenEsignRequest } from "@/pages/esign/use-open-esign-request.hook.ts";
import { useEsignRequest } from "@/queries/use-esign.query.ts";
import { useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";

const ESIGN_REQUEST_MODAL_KEY = "esign_request";
const ESIGN_REQUEST_DOWNLOAD_ACTION = "download";

export function useEsignRequestDeeplink() {
  const [searchParams, setSearchParams] = useSearchParams();
  const openEsignRequest = useOpenEsignRequest();
  const { downloadFile } = useDownloadHelper();

  const requestId = searchParams.get("id");
  const action = searchParams.get("action");
  const isEsignRequest = searchParams.get("modal") === ESIGN_REQUEST_MODAL_KEY && !!requestId;

  const { data: request } = useEsignRequest(requestId ?? "", isEsignRequest);
  const handledRef = useRef(false);

  useEffect(() => {
    if (!isEsignRequest || !request || handledRef.current) return;
    handledRef.current = true;

    if (action === ESIGN_REQUEST_DOWNLOAD_ACTION) {
      downloadFile({ apiCall: () => apiEsign.getRequestSignedDocument(request.public_id) });
    } else {
      openEsignRequest(request);
    }

    const next = new URLSearchParams(searchParams);
    next.delete("modal");
    next.delete("id");
    next.delete("action");
    setSearchParams(next, { replace: true });
  }, [
    isEsignRequest,
    request,
    action,
    openEsignRequest,
    downloadFile,
    searchParams,
    setSearchParams,
  ]);
}
